export default "__VITE_ASSET__CAXNxrGf__"